module.exports = __webpack_public_path__ + "img/11.57f63823.jpg";